/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Article_TitleInputs */

const en_funnel_demo_article_title = /** @type {(inputs: Funnel_Demo_Article_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your article`)
};

const es_funnel_demo_article_title = /** @type {(inputs: Funnel_Demo_Article_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu artículo`)
};

/**
* | output |
* | --- |
* | "Your article" |
*
* @param {Funnel_Demo_Article_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_article_title = /** @type {((inputs?: Funnel_Demo_Article_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Article_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_article_title(inputs)
	return en_funnel_demo_article_title(inputs)
});